<script lang="ts">
    import { _ } from "svelte-i18n"
    import ChevronDownIcon from "svelte-material-icons/ChevronDown.svelte"
    import { inquiry } from "../../../../functionTools/offerAssistant"
    import Select from "svelte-select/Select.svelte"
    import { selectTouchFix } from "../../../../lib/actions/selectTouchFix"

    const customerTypesSelectOptions = [
        {
            value: "end",
            localizationKey: "inquiry.customer-type.end",
            selected: true,
        },
        {
            value: "business",
            localizationKey: "inquiry.customer-type.business",
        },
    ]

    let customerType = {
        label: $_(customerTypesSelectOptions[0].localizationKey),
        value: customerTypesSelectOptions[0].value,
    }
</script>

<div class="row">
    <div class="col-md-12" use:selectTouchFix>
        <Select
            placeholder={$_("integrations.selectColorStyle")}
            items={Object.entries(customerTypesSelectOptions).map((customerType) => ({
                label: $_(customerType[1].localizationKey),
                value: customerType[1].value,
            }))}
            bind:value={customerType}
            on:change={(e) => {
                $inquiry.customerType = e.detail.value
            }}
            hideEmptyState
            clearable={false}
            showChevron={true}
        />
    </div>
</div>

<style lang="less"></style>
